export default "__VITE_ASSET__Cn_Tm_de__"